<section [style.height]="isSingleUpload ? componentMinHeight : '100%'" [style.minHeight]="componentMinHeight" class="tw-w-full tw-bg-white tw-flex tw-gap-4 tw-flex-wrap">
  @if(isSingleUpload && (getFormControl('path')?.value || uploadProgressList[0])){ @if(uploadProgressList[0]){
  <div class="tw-border tw-border-2 tw-rounded-xl tw-border-blue-500 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full">
    <progress-circle [isInfinite]="false" [uploadProgress]="uploadProgressList[0]"></progress-circle>
  </div>
  }@else {
  <app-uploaded-file
    class="tw-block tw-h-full tw-w-full"
    (click)="toggleGallery(0)"
    [useImageCropper]="false"
    [fileObject]="singleFileList"
    [canEditFileName]="canEditFileName"
    [displayFilename]="displayFilename"
    (deleteFile)="deleteFile(0)"
    (nameChanged)="fileChanged.emit(fileList.value)"
  ></app-uploaded-file>
  } } @else if(!isSingleUpload && multiFileList?.value?.length){
  <app-multiple-file-upload
    class="tw-block tw-w-full tw-h-full"
    [fileList]="multiFileList"
    [isMultipleInput]="isMultipleInput"
    [maxFilesToUpload]="maxFilesToUpload"
    [accept]="accept"
    [canEditFileName]="canEditFileName"
    [displayFilename]="displayFilename"
    [height]="height"
    [width]="width"
    [warningMessage]="warningMessage"
    [hint]="hint"
    [tooltip]="tooltip"
    [minFileSize]="minFileSize"
    [maxFileSize]="maxFileSize"
    [uploadProgressList]="uploadProgressList"
    [useImageCropper]="false"
    (deleteFile)="deleteFile($event)"
    (toggleGallery)="toggleGallery($event)"
    (nameChanged)="fileChanged.emit(fileList.value)"
    (fileChanged)="onFileChanged($event)"
  ></app-multiple-file-upload>
  } @else{
  <app-upload-input
    class="tw-w-full tw-block"
    [accept]="accept"
    [label]="label"
    [hint]="hint"
    [tooltip]="tooltip"
    [isMultipleInput]="isMultipleInput"
    [maxFileSize]="maxFileSize"
    [minFileSize]="minFileSize"
    [showIcon]="showIcon"
    [fileList]="fileList"
    [maxFilesToUpload]="maxFilesToUpload"
    [warningMessage]="warningMessage"
    (fileChanged)="onFileChanged($event)"
  ></app-upload-input>
  }
</section>

@if (isModalOpened(deleteModalId)) {
<delete-modal message="Are you sure you want to delete this file?" [id]="deleteModalId" (onDelete)="confirmDeleting()" (onCancel)="cancelDelete()"></delete-modal>
} @if (isGalleryOpened) {
<div class="gallery-container" [id]="selectedFileIndex">
  <gallery [images]="filesObjects?.length ? filesObjects : [singleFileList]" [useCropper]="false" [selectedIndex]="selectedFileIndex" (onGalleryClose)="toggleGallery()"></gallery>
</div>
}
